import CloseIcon from "@/assets/icons/closeIcon";
import { Button } from "@/shared/components/base-button";
import React from "react";

interface ModalErrorProps {
  message: string;
  title?: string;
  styles?: React.CSSProperties;
  onClose: () => void;
}

export const ModalError: React.FC<ModalErrorProps> = ({
  message,
  styles,
  title,
  onClose,
}) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/50"
      style={styles}
    >
      <div className="bg-white rounded-lg shadow-lg p-6 max-w-lg w-full relative min-h-[180px]">
        <button
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          onClick={onClose}
          aria-label="Cerrar"
        >
          <CloseIcon width={24} height={24} />
        </button>
        <div className="flex flex-col items-center h-full justify-between min-h-[180px]">
          <h2 className="text-lg font-semibold text-state-error-foreground mb-6 mt-2">
            {title || "Mensaje"}
          </h2>
          <div className="flex-1 flex items-center justify-center w-full">
            <p
              className="text-gray-700 text-center mb-4 w-full wrap-break-word"
              style={{ whiteSpace: "pre-line" }}
            >
              {message}
            </p>
          </div>
          <div className="flex justify-center w-full mt-8 mb-2">
            <Button appearance="secondary" onClick={onClose}>
              Cerrar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
